export default __webpack_public_path__ + "static/飞书20210918-142430-en-0366965dd44886b312ad50ef50b08c1d.png";